import { useContext } from 'react';
import { SignalRContext } from '@/contexts/SignalRContext';

/**
 * Hook to access SignalR context
 * @throws Error if used outside of SignalRProvider
 */
export function useSignalR() {
  const context = useContext(SignalRContext);
  if (context === undefined) {
    throw new Error('useSignalR must be used within a SignalRProvider');
  }
  return context;
}
